// ── 예시 데이터 (신규 가입자 기본값 — 실제 레시피와 무관한 가상의 분식집 메뉴입니다)

export const CATEGORIES = [
  {
    name: "반제품 — 소스 / 양념",
    items: [
      {
        id: "S01",
        recipeCode: "R001",
        name: "특제 간장 소스",
        type: "semi",
        total_input: 495,
        total_output: 495,
        serving_g: 50,
        note: "모든 재료를 잘 섞어 완성 후 냉장 보관. 하루 숙성하면 더 맛있어요.",
        ingredients: [
          { name: "진간장",   qty: 200 },
          { name: "고춧가루", qty: 30  },
          { name: "참기름",   qty: 15  },
          { name: "다진마늘", qty: 20  },
          { name: "설탕",     qty: 30  },
          { name: "물",       qty: 150 },
          { name: "대파",     qty: 50  },
        ]
      },
      {
        id: "S02",
        recipeCode: "R002",
        name: "비빔 소스",
        type: "semi",
        total_input: 550,
        total_output: 550,
        serving_g: 60,
        note: "고추장 베이스에 양념 재료를 잘 섞기. 냉장 보관.",
        ingredients: [
          { name: "고추장",   qty: 300 },
          { name: "참기름",   qty: 50  },
          { name: "설탕",     qty: 80  },
          { name: "식초",     qty: 60  },
          { name: "진간장",   qty: 30  },
          { name: "다진마늘", qty: 30  },
        ]
      },
      {
        id: "S03",
        recipeCode: "R003",
        name: "떡볶이 소스",
        type: "semi",
        total_input: 3200,
        total_output: 3200,
        serving_g: 150,
        note: "모든 재료를 잘 섞어 냉장 보관. 사용 전 잘 저어 쓰기.",
        ingredients: [
          { name: "고추장",   qty: 500  },
          { name: "물",       qty: 2000 },
          { name: "진간장",   qty: 200  },
          { name: "설탕",     qty: 300  },
          { name: "물엿",     qty: 100  },
          { name: "다진마늘", qty: 100  },
        ]
      },
      {
        id: "S04",
        recipeCode: "R004",
        name: "마늘 마요소스",
        type: "semi",
        total_input: 585,
        total_output: 585,
        serving_g: 50,
        note: "마늘을 곱게 다진 후 마요네즈와 잘 섞기. 냉장 2일 이내 사용.",
        ingredients: [
          { name: "마요네즈", qty: 500 },
          { name: "다진마늘", qty: 30  },
          { name: "꿀",       qty: 50  },
          { name: "후춧가루", qty: 5   },
        ]
      },
    ]
  },
  {
    name: "반제품 — 육수 / 기본재료",
    items: [
      {
        id: "S05",
        recipeCode: "R005",
        name: "기본 육수",
        type: "semi",
        total_input: 8650,
        total_output: 7500,
        serving_g: 400,
        note: "중불로 20분 끓인 후 체에 걸러 사용. 냉장 3일 이내 소진.",
        ingredients: [
          { name: "물",       qty: 8000 },
          { name: "무",       qty: 400  },
          { name: "다시마",   qty: 20   },
          { name: "멸치액젓", qty: 100  },
          { name: "소금",     qty: 30   },
          { name: "대파",     qty: 50   },
          { name: "다진마늘", qty: 50   },
        ]
      },
      {
        id: "S06",
        recipeCode: "R006",
        name: "쌀밥",
        type: "semi",
        total_input: 1760,
        total_output: 1750,
        serving_g: 200,
        note: "쌀 : 물 = 1 : 1.2 비율. 취사 후 5분 뜸 들이기.",
        ingredients: [
          { name: "쌀",  qty: 800 },
          { name: "물",  qty: 960 },
        ]
      },
      {
        id: "S07",
        recipeCode: "R007",
        name: "계란 지단",
        type: "semi",
        total_input: 515,
        total_output: 360,
        serving_g: 20,
        note: "계란 풀어 소금 간 후 얇게 부쳐 식힌 뒤 채 썰기. 계란 10개 기준.",
        ingredients: [
          { name: "계란",   qty: 500 },
          { name: "식용유", qty: 10  },
          { name: "소금",   qty: 5   },
        ]
      },
      {
        id: "S08",
        recipeCode: "R008",
        name: "삶은 소면",
        type: "semi",
        total_input: 90,
        total_output: 130,
        serving_g: 130,
        note: "끓는 물에 3분 삶은 후 찬물에 헹궈 보관. 1인분 기준.",
        ingredients: [
          { name: "소면", qty: 90 },
        ]
      },
      {
        id: "S09",
        recipeCode: "R009",
        name: "불린 당면",
        type: "semi",
        total_input: 100,
        total_output: 150,
        serving_g: 80,
        note: "찬물에 30분 이상 불린 후 사용. 불린 후 바로 조리.",
        ingredients: [
          { name: "당면", qty: 100 },
        ]
      },
    ]
  },
  {
    name: "반제품 — 주재료",
    items: [
      {
        id: "S10",
        recipeCode: "R010",
        name: "볶음 채소",
        type: "semi",
        total_input: 1040,
        total_output: 800,
        serving_g: 50,
        note: "채소를 썰어 식용유에 볶은 후 소금으로 간 하기. 식혀서 사용.",
        ingredients: [
          { name: "당근",   qty: 500 },
          { name: "시금치", qty: 300 },
          { name: "숙주",   qty: 200 },
          { name: "식용유", qty: 30  },
          { name: "소금",   qty: 10  },
        ]
      },
      {
        id: "S11",
        recipeCode: "R011",
        name: "불고기 (반제품)",
        type: "semi",
        total_input: 780,
        total_output: 650,
        serving_g: 70,
        note: "다짐소고기에 양념 버무려 냉장 30분 이상 숙성 후 센 불에 볶기.",
        ingredients: [
          { name: "다짐소고기", qty: 600 },
          { name: "진간장",     qty: 80  },
          { name: "설탕",       qty: 40  },
          { name: "다진마늘",   qty: 30  },
          { name: "참기름",     qty: 20  },
          { name: "식용유",     qty: 10  },
        ]
      },
      {
        id: "S12",
        recipeCode: "R012",
        name: "제육볶음 (반제품)",
        type: "semi",
        total_input: 880,
        total_output: 700,
        serving_g: 200,
        note: "돼지고기에 특제 간장 소스 버무려 숙성. 양파는 나중에 넣고 볶기.",
        ingredients: [
          { name: "돼지고기 (앞다리살)", qty: 500 },
          { name: "특제 간장 소스",       qty: 150 },
          { name: "양파",                 qty: 200 },
          { name: "식용유",               qty: 30  },
        ]
      },
      {
        id: "S13",
        recipeCode: "R013",
        name: "참치마요",
        type: "semi",
        total_input: 343,
        total_output: 343,
        serving_g: 80,
        note: "참치 기름 완전히 제거 후 마요네즈와 잘 섞기. 당일 사용 권장.",
        ingredients: [
          { name: "참치캔 (살코기)", qty: 280 },
          { name: "마요네즈",        qty: 60  },
          { name: "후춧가루",        qty: 3   },
        ]
      },
      {
        id: "S14",
        recipeCode: "R014",
        name: "시금치 나물",
        type: "semi",
        total_input: 328,
        total_output: 280,
        serving_g: 30,
        note: "시금치 데친 후 물기 꼭 짜고 참기름·소금·마늘로 버무리기.",
        ingredients: [
          { name: "시금치",   qty: 300 },
          { name: "참기름",   qty: 15  },
          { name: "소금",     qty: 3   },
          { name: "다진마늘", qty: 10  },
        ]
      },
    ]
  },
  {
    name: "판매 메뉴",
    items: [
      {
        id: "M01",
        recipeCode: "M001",
        name: "기본 김밥",
        type: "menu",
        price: 4500,
        total_input: 280,
        total_output: 280,
        serving_g: 280,
        note: "재료 순서대로 올려 단단히 말기. 참기름 마지막에 바르기.",
        ingredients: [
          { name: "쌀밥",     qty: 130 },
          { name: "계란 지단", qty: 20 },
          { name: "볶음 채소", qty: 30 },
          { name: "단무지",    qty: 20 },
          { name: "맛살",      qty: 15 },
          { name: "김밥김",    qty: 1, unit: "장" },
          { name: "참기름",    qty: 2  },
        ]
      },
      {
        id: "M02",
        recipeCode: "M002",
        name: "참치 김밥",
        type: "menu",
        price: 6500,
        total_input: 287,
        total_output: 287,
        serving_g: 287,
        note: "참치마요를 가운데 넣고 단단히 말기.",
        ingredients: [
          { name: "쌀밥",       qty: 130 },
          { name: "계란 지단",  qty: 20  },
          { name: "참치마요",   qty: 70  },
          { name: "볶음 채소",  qty: 20  },
          { name: "시금치 나물", qty: 25 },
          { name: "단무지",     qty: 20  },
          { name: "김밥김",     qty: 1, unit: "장" },
          { name: "참기름",     qty: 2   },
        ]
      },
      {
        id: "M03",
        recipeCode: "M003",
        name: "불고기 김밥",
        type: "menu",
        price: 7000,
        total_input: 282,
        total_output: 282,
        serving_g: 282,
        note: "불고기 식힌 후 재료 올려 말기.",
        ingredients: [
          { name: "쌀밥",          qty: 130 },
          { name: "계란 지단",     qty: 20  },
          { name: "불고기 (반제품)", qty: 60 },
          { name: "볶음 채소",     qty: 20  },
          { name: "마늘 마요소스", qty: 15  },
          { name: "단무지",        qty: 20  },
          { name: "김밥김",        qty: 1, unit: "장" },
          { name: "참기름",        qty: 2   },
        ]
      },
      {
        id: "M04",
        recipeCode: "M004",
        name: "잔치국수",
        type: "menu",
        price: 6000,
        total_input: 590,
        total_output: 590,
        serving_g: 590,
        note: "면 삶아 헹군 후 육수 붓고 고명 올리기.",
        ingredients: [
          { name: "삶은 소면", qty: 130 },
          { name: "기본 육수", qty: 400 },
          { name: "계란 지단", qty: 20  },
          { name: "볶음 채소", qty: 30  },
          { name: "참깨",      qty: 3   },
          { name: "김가루",    qty: 5   },
        ]
      },
      {
        id: "M05",
        recipeCode: "M005",
        name: "비빔국수",
        type: "menu",
        price: 6500,
        total_input: 243,
        total_output: 243,
        serving_g: 243,
        note: "면 삶아 헹군 후 소스와 잘 비비기. 참깨로 마무리.",
        ingredients: [
          { name: "삶은 소면",     qty: 130 },
          { name: "비빔 소스",     qty: 60  },
          { name: "볶음 채소",     qty: 30  },
          { name: "계란 지단",     qty: 20  },
          { name: "참깨",          qty: 3   },
        ]
      },
      {
        id: "M06",
        recipeCode: "M006",
        name: "떡볶이",
        type: "menu",
        price: 5500,
        total_input: 370,
        total_output: 350,
        serving_g: 350,
        note: "소스에 재료 넣고 중불에 졸이기. 국물 농도 조절.",
        ingredients: [
          { name: "가래떡",     qty: 150 },
          { name: "어묵",       qty: 50  },
          { name: "대파",       qty: 20  },
          { name: "떡볶이 소스", qty: 150 },
        ]
      },
      {
        id: "M07",
        recipeCode: "M007",
        name: "제육 덮밥",
        type: "menu",
        price: 8500,
        total_input: 453,
        total_output: 453,
        serving_g: 453,
        note: "밥 위에 뜨겁게 볶은 제육볶음 올리기. 참깨 뿌려 마무리.",
        ingredients: [
          { name: "쌀밥",            qty: 200 },
          { name: "제육볶음 (반제품)", qty: 200 },
          { name: "볶음 채소",        qty: 50  },
          { name: "참깨",             qty: 3   },
        ]
      },
      {
        id: "M08",
        recipeCode: "M008",
        name: "잡채",
        type: "menu",
        price: 8000,
        total_input: 260,
        total_output: 260,
        serving_g: 260,
        note: "당면과 재료를 간장·참기름으로 볶아 완성. 당면이 뭉치지 않게 주의.",
        ingredients: [
          { name: "불린 당면",       qty: 100 },
          { name: "불고기 (반제품)", qty: 80  },
          { name: "볶음 채소",       qty: 50  },
          { name: "진간장",          qty: 15  },
          { name: "참기름",          qty: 10  },
          { name: "설탕",            qty: 5   },
        ]
      },
    ]
  }
];

export const PRICES = [
  // ── 원재료 ──────────────────────────────────────────────────
  { code: "P001", name: "쌀",              spec: "20kg/포",         unit: "포",   price: 52000, net_g: 20000 },
  { code: "P002", name: "돼지고기 (앞다리살)", spec: "1kg",          unit: "kg",   price: 8500,  net_g: 1000  },
  { code: "P003", name: "다짐소고기",       spec: "1kg",             unit: "kg",   price: 14000, net_g: 1000  },
  { code: "P004", name: "계란",             spec: "30개/판",         unit: "판",   price: 7200,  net_g: 2100  },
  { code: "P005", name: "당근",             spec: "10kg/박스",       unit: "박스", price: 12000, net_g: 10000 },
  { code: "P006", name: "시금치",           spec: "1kg/팩",          unit: "팩",   price: 3500,  net_g: 1000  },
  { code: "P007", name: "숙주",             spec: "1kg/봉",          unit: "봉",   price: 1500,  net_g: 1000  },
  { code: "P008", name: "양파",             spec: "3kg/망",          unit: "망",   price: 4500,  net_g: 3000  },
  { code: "P009", name: "무",               spec: "1.5kg/개",        unit: "개",   price: 2000,  net_g: 1500  },
  { code: "P010", name: "대파",             spec: "800g/단",         unit: "단",   price: 2500,  net_g: 800   },
  { code: "P011", name: "다진마늘",         spec: "1kg/팩",          unit: "팩",   price: 9000,  net_g: 1000  },
  { code: "P012", name: "오이",             spec: "500g/3개",        unit: "묶음", price: 1800,  net_g: 500   },
  { code: "P013", name: "진간장",           spec: "15L/통",          unit: "통",   price: 45000, net_g: 14500 },
  { code: "P014", name: "고추장",           spec: "3kg/통",          unit: "통",   price: 18000, net_g: 3000  },
  { code: "P015", name: "참기름",           spec: "1.8L/통",         unit: "통",   price: 22000, net_g: 1800  },
  { code: "P016", name: "마요네즈",         spec: "3kg/팩",          unit: "팩",   price: 13500, net_g: 3000  },
  { code: "P017", name: "식용유",           spec: "18L/통",          unit: "통",   price: 38000, net_g: 17000 },
  { code: "P018", name: "설탕",             spec: "15kg/포",         unit: "포",   price: 22000, net_g: 15000 },
  { code: "P019", name: "소금",             spec: "5kg/팩",          unit: "팩",   price: 8000,  net_g: 5000  },
  { code: "P020", name: "고춧가루",         spec: "3kg/팩",          unit: "팩",   price: 20000, net_g: 3000  },
  { code: "P021", name: "후춧가루",         spec: "420g/통",         unit: "통",   price: 9000,  net_g: 420   },
  { code: "P022", name: "물엿",             spec: "10kg/통",         unit: "통",   price: 8500,  net_g: 10000 },
  { code: "P023", name: "꿀",               spec: "2.4kg/통",        unit: "통",   price: 18000, net_g: 2400  },
  { code: "P024", name: "식초",             spec: "1.8L/병",         unit: "병",   price: 3500,  net_g: 1800  },
  { code: "P025", name: "소면",             spec: "10kg/박스",       unit: "박스", price: 25000, net_g: 10000 },
  { code: "P026", name: "당면",             spec: "1kg/팩",          unit: "팩",   price: 5500,  net_g: 1000  },
  { code: "P027", name: "가래떡",           spec: "10kg/박스",       unit: "박스", price: 28000, net_g: 10000 },
  { code: "P028", name: "어묵",             spec: "1kg/팩",          unit: "팩",   price: 5500,  net_g: 1000  },
  { code: "P029", name: "참치캔 (살코기)",  spec: "140g×2캔/팩",     unit: "팩",   price: 3200,  net_g: 280   },
  { code: "P030", name: "맛살",             spec: "1kg/팩",          unit: "팩",   price: 5500,  net_g: 1000  },
  { code: "P031", name: "단무지",           spec: "1.5kg/팩",        unit: "팩",   price: 5800,  net_g: 1500  },
  { code: "P032", name: "김밥김",           spec: "100매/팩",        unit: "팩",   price: 13500, net_g: 100   },
  { code: "P033", name: "참깨",             spec: "1kg/팩",          unit: "팩",   price: 9000,  net_g: 1000  },
  { code: "P034", name: "다시마",           spec: "100g/팩",         unit: "팩",   price: 4000,  net_g: 100   },
  { code: "P035", name: "멸치액젓",         spec: "1.8L/병",         unit: "병",   price: 6000,  net_g: 1800  },
  { code: "P036", name: "김가루",           spec: "1kg/팩",          unit: "팩",   price: 20000, net_g: 1000  },

  // ── 반제품 단가 (레시피 원가 자동 계산용) ──────────────────
  {
    code: "SS01", name: "특제 간장 소스",
    spec: "R001 | 1회분 50g", unit: "g",
    price: 1383, net_g: 495,
    isSemi: true, recipeId: "S01"
  },
  {
    code: "SS02", name: "비빔 소스",
    spec: "R002 | 1회분 60g", unit: "g",
    price: 3007, net_g: 550,
    isSemi: true, recipeId: "S02"
  },
  {
    code: "SS03", name: "떡볶이 소스",
    spec: "R003 | 1회분 150g", unit: "g",
    price: 5046, net_g: 3200,
    isSemi: true, recipeId: "S03"
  },
  {
    code: "SS04", name: "마늘 마요소스",
    spec: "R004 | 1회분 50g", unit: "g",
    price: 3002, net_g: 585,
    isSemi: true, recipeId: "S04"
  },
  {
    code: "SS05", name: "기본 육수",
    spec: "R005 | 1회분 400g", unit: "g",
    price: 2319, net_g: 7500,
    isSemi: true, recipeId: "S05"
  },
  {
    code: "SS06", name: "쌀밥",
    spec: "R006 | 1회분 200g", unit: "g",
    price: 2080, net_g: 1750,
    isSemi: true, recipeId: "S06"
  },
  {
    code: "SS07", name: "계란 지단",
    spec: "R007 | 1회분 20g", unit: "g",
    price: 1745, net_g: 360,
    isSemi: true, recipeId: "S07"
  },
  {
    code: "SS08", name: "삶은 소면",
    spec: "R008 | 1회분 130g", unit: "g",
    price: 225, net_g: 130,
    isSemi: true, recipeId: "S08"
  },
  {
    code: "SS09", name: "불린 당면",
    spec: "R009 | 1회분 80g", unit: "g",
    price: 550, net_g: 150,
    isSemi: true, recipeId: "S09"
  },
  {
    code: "SS10", name: "볶음 채소",
    spec: "R010 | 1회분 50g", unit: "g",
    price: 2033, net_g: 800,
    isSemi: true, recipeId: "S10"
  },
  {
    code: "SS11", name: "불고기 (반제품)",
    spec: "R011 | 1회분 70g", unit: "g",
    price: 9243, net_g: 650,
    isSemi: true, recipeId: "S11"
  },
  {
    code: "SS12", name: "제육볶음 (반제품)",
    spec: "R012 | 1회분 200g", unit: "g",
    price: 5036, net_g: 700,
    isSemi: true, recipeId: "S12"
  },
  {
    code: "SS13", name: "참치마요",
    spec: "R013 | 1회분 80g", unit: "g",
    price: 3534, net_g: 343,
    isSemi: true, recipeId: "S13"
  },
  {
    code: "SS14", name: "시금치 나물",
    spec: "R014 | 1회분 30g", unit: "g",
    price: 1328, net_g: 280,
    isSemi: true, recipeId: "S14"
  },

  // ── 판매 메뉴 원가 (참고용) ─────────────────────────────────
  {
    code: "SM01", name: "기본 김밥",
    spec: "M001 | 1인분 280g", unit: "g",
    price: 646, net_g: 280,
    isSemi: true, recipeId: "M01"
  },
  {
    code: "SM02", name: "참치 김밥",
    spec: "M002 | 1인분 287g", unit: "g",
    price: 1378, net_g: 287,
    isSemi: true, recipeId: "M02"
  },
  {
    code: "SM03", name: "불고기 김밥",
    spec: "M003 | 1인분 282g", unit: "g",
    price: 1468, net_g: 282,
    isSemi: true, recipeId: "M03"
  },
  {
    code: "SM04", name: "잔치국수",
    spec: "M004 | 1인분 590g", unit: "g",
    price: 649, net_g: 590,
    isSemi: true, recipeId: "M04"
  },
  {
    code: "SM05", name: "비빔국수",
    spec: "M005 | 1인분 243g", unit: "g",
    price: 861, net_g: 243,
    isSemi: true, recipeId: "M05"
  },
  {
    code: "SM06", name: "떡볶이",
    spec: "M006 | 1인분 350g", unit: "g",
    price: 995, net_g: 350,
    isSemi: true, recipeId: "M06"
  },
  {
    code: "SM07", name: "제육 덮밥",
    spec: "M007 | 1인분 453g", unit: "g",
    price: 1831, net_g: 453,
    isSemi: true, recipeId: "M07"
  },
  {
    code: "SM08", name: "잡채",
    spec: "M008 | 1인분 260g", unit: "g",
    price: 1807, net_g: 260,
    isSemi: true, recipeId: "M08"
  },
];

// ── 인테리어 업종 기본 데이터 ─────────────────────────────────────────────
// serving_g = 기준 면적(m²), total_output = 동일값
// ingredient.unit = 자재 단위(m², kg, L 등), lossRate = 손실률(%)

export const INTERIOR_CATEGORIES = [
  {
    name: "도배",
    items: [
      {
        id: "INT01", recipeCode: "INT001",
        name: "합지 도배 (10m²)",
        type: "menu",
        total_output: 10, total_input: 10, serving_g: 10,
        note: "합지 벽지 기준. 방 1칸(약 10m²) 기준 자재량.",
        selling_price: 0,
        ingredients: [
          { name: "합지 벽지",  qty: 10,  unit: "m²",  lossRate: 15 },
          { name: "도배풀",     qty: 1.2, unit: "kg",  lossRate: 5  },
        ]
      },
      {
        id: "INT02", recipeCode: "INT002",
        name: "실크 도배 (10m²)",
        type: "menu",
        total_output: 10, total_input: 10, serving_g: 10,
        note: "실크 벽지(0.53m 폭) 기준. 초배지 포함.",
        selling_price: 0,
        ingredients: [
          { name: "실크 벽지",  qty: 10,  unit: "m²",  lossRate: 15 },
          { name: "초배지",     qty: 10,  unit: "m²",  lossRate: 10 },
          { name: "도배풀",     qty: 1.5, unit: "kg",  lossRate: 5  },
        ]
      },
    ]
  },
  {
    name: "타일 시공",
    items: [
      {
        id: "INT03", recipeCode: "INT003",
        name: "바닥 타일 300x300 (10m²)",
        type: "menu",
        total_output: 10, total_input: 10, serving_g: 10,
        note: "300×300mm 바닥 타일. 레벨링 모르타르 포함.",
        selling_price: 0,
        ingredients: [
          { name: "바닥 타일",      qty: 10, unit: "m²",  lossRate: 10 },
          { name: "타일 접착제",    qty: 5,  unit: "kg",  lossRate: 5  },
          { name: "타일 줄눈재",    qty: 2,  unit: "kg",  lossRate: 5  },
          { name: "레벨 모르타르",  qty: 20, unit: "kg",  lossRate: 5  },
        ]
      },
      {
        id: "INT04", recipeCode: "INT004",
        name: "욕실 벽 타일 600x300 (10m²)",
        type: "menu",
        total_output: 10, total_input: 10, serving_g: 10,
        note: "욕실 벽면 타일 시공 기준.",
        selling_price: 0,
        ingredients: [
          { name: "벽 타일",       qty: 10,  unit: "m²",  lossRate: 10 },
          { name: "타일 접착제",   qty: 4,   unit: "kg",  lossRate: 5  },
          { name: "타일 줄눈재",   qty: 1.5, unit: "kg",  lossRate: 5  },
        ]
      },
    ]
  },
  {
    name: "마루 / 바닥재",
    items: [
      {
        id: "INT05", recipeCode: "INT005",
        name: "강마루 시공 (10m²)",
        type: "menu",
        total_output: 10, total_input: 10, serving_g: 10,
        note: "강마루 T6 기준. 걸레받이·언더레이 포함.",
        selling_price: 0,
        ingredients: [
          { name: "강마루",        qty: 10,  unit: "m²",  lossRate: 10 },
          { name: "완충 언더레이", qty: 10,  unit: "m²",  lossRate: 5  },
          { name: "걸레받이 몰딩", qty: 12,  unit: "m",   lossRate: 10 },
          { name: "마루 접착제",   qty: 0.5, unit: "L",   lossRate: 5  },
        ]
      },
    ]
  },
  {
    name: "페인트 도장",
    items: [
      {
        id: "INT06", recipeCode: "INT006",
        name: "내부 벽면 페인트 (10m²)",
        type: "menu",
        total_output: 10, total_input: 10, serving_g: 10,
        note: "내부 벽면 2회 도장. 프라이머 포함.",
        selling_price: 0,
        ingredients: [
          { name: "내부 페인트", qty: 1.5, unit: "L",   lossRate: 10 },
          { name: "프라이머",    qty: 0.5, unit: "L",   lossRate: 10 },
        ]
      },
    ]
  },
  {
    name: "부자재",
    items: [
      {
        id: "INT07", recipeCode: "INT007",
        name: "석고보드 시공 (10m²)",
        type: "semi",
        total_output: 10, total_input: 10, serving_g: 10,
        note: "9.5T 석고보드 기준. 경량 철골 포함.",
        selling_price: 0,
        ingredients: [
          { name: "석고보드 9.5T", qty: 10,  unit: "m²",  lossRate: 10 },
          { name: "경량 철골 (C형)", qty: 5, unit: "m",   lossRate: 5  },
          { name: "셀프 태핑 나사", qty: 150, unit: "ea" },
        ]
      },
    ]
  },
];

export const INTERIOR_PRICES = [
  // ── 도배
  { code: "IP01", name: "합지 벽지",      spec: "1롤 (5.3m²)",   unit: "m²",  price: 3500,  net_g: 1, category: "도배"   },
  { code: "IP02", name: "실크 벽지",      spec: "1롤 (15m²)",    unit: "m²",  price: 8000,  net_g: 1, category: "도배"   },
  { code: "IP03", name: "초배지",         spec: "1롤 (10m²)",    unit: "m²",  price: 1500,  net_g: 1, category: "도배"   },
  { code: "IP04", name: "도배풀",         spec: "20kg/포",        unit: "kg",  price: 25000, net_g: 1, category: "도배"   },
  // ── 타일
  { code: "IP05", name: "바닥 타일",      spec: "300x300 (1m²)", unit: "m²",  price: 15000, net_g: 1, category: "타일"   },
  { code: "IP06", name: "벽 타일",        spec: "600x300 (1m²)", unit: "m²",  price: 18000, net_g: 1, category: "타일"   },
  { code: "IP07", name: "타일 접착제",    spec: "20kg/포",        unit: "kg",  price: 18000, net_g: 1, category: "타일"   },
  { code: "IP08", name: "타일 줄눈재",    spec: "5kg/포",         unit: "kg",  price: 8000,  net_g: 1, category: "타일"   },
  { code: "IP09", name: "레벨 모르타르",  spec: "25kg/포",        unit: "kg",  price: 12000, net_g: 1, category: "타일"   },
  // ── 마루
  { code: "IP10", name: "강마루",         spec: "T6 (1m²)",      unit: "m²",  price: 22000, net_g: 1, category: "마루"   },
  { code: "IP11", name: "완충 언더레이",  spec: "1m²",            unit: "m²",  price: 2000,  net_g: 1, category: "마루"   },
  { code: "IP12", name: "걸레받이 몰딩",  spec: "2.4m/ea",        unit: "m",   price: 2500,  net_g: 1, category: "마루"   },
  { code: "IP13", name: "마루 접착제",    spec: "1L/캔",          unit: "L",   price: 15000, net_g: 1, category: "마루"   },
  // ── 페인트
  { code: "IP14", name: "내부 페인트",    spec: "4L/캔",          unit: "L",   price: 35000, net_g: 1, category: "페인트" },
  { code: "IP15", name: "프라이머",       spec: "4L/캔",          unit: "L",   price: 28000, net_g: 1, category: "페인트" },
  // ── 부자재
  { code: "IP16", name: "석고보드 9.5T",  spec: "1220x2440mm",    unit: "m²",  price: 8500,  net_g: 1, category: "부자재" },
  { code: "IP17", name: "경량 철골 (C형)",spec: "3.6m/ea",         unit: "m",   price: 3800,  net_g: 1, category: "부자재" },
  { code: "IP18", name: "셀프 태핑 나사", spec: "100ea/box",       unit: "ea",  price: 4500,  net_g: 1, category: "부자재" },
];

// ── 미용 업종 기본 데이터 ──────────────────────────────────────────
export const BEAUTY_CATEGORIES = [
  {
    name: "헤어 서비스",
    items: [
      { id: "BT01", recipeCode: "BT001", name: "커트", type: "menu", total_output: 1, total_input: 1, serving_g: 1, note: "일반 커트", selling_price: 0, ingredients: [] },
      { id: "BT02", recipeCode: "BT002", name: "염색 (단색)", type: "menu", total_output: 1, total_input: 1, serving_g: 1, note: "단색 염색", selling_price: 0, ingredients: [{ name: "염색약", qty: 60, unit: "g", lossRate: 5 }, { name: "산화제", qty: 60, unit: "g", lossRate: 5 }] },
      { id: "BT03", recipeCode: "BT003", name: "파마", type: "menu", total_output: 1, total_input: 1, serving_g: 1, note: "일반 파마", selling_price: 0, ingredients: [{ name: "파마약 1제", qty: 100, unit: "g", lossRate: 5 }, { name: "파마약 2제", qty: 100, unit: "g", lossRate: 5 }] },
    ]
  },
];

export const BEAUTY_PRICES = [
  { code: "BP01", name: "염색약", spec: "100g", unit: "g", price: 150, net_g: 1, category: "헤어케어" },
  { code: "BP02", name: "산화제", spec: "100g", unit: "g", price: 80, net_g: 1, category: "헤어케어" },
  { code: "BP03", name: "파마약 1제", spec: "100g", unit: "g", price: 120, net_g: 1, category: "헤어케어" },
  { code: "BP04", name: "파마약 2제", spec: "100g", unit: "g", price: 100, net_g: 1, category: "헤어케어" },
];

// ── 자동차 업종 기본 데이터 ──────────────────────────────────────────
export const AUTO_CATEGORIES = [
  {
    name: "정비 서비스",
    items: [
      { id: "AT01", recipeCode: "AT001", name: "엔진오일 교환", type: "menu", total_output: 1, total_input: 1, serving_g: 1, note: "승용차 기준", selling_price: 0, ingredients: [{ name: "엔진오일", qty: 4, unit: "L", lossRate: 0 }, { name: "오일필터", qty: 1, unit: "ea", lossRate: 0 }] },
      { id: "AT02", recipeCode: "AT002", name: "타이어 교체 (1개)", type: "menu", total_output: 1, total_input: 1, serving_g: 1, note: "교체 작업비 기준", selling_price: 0, ingredients: [] },
    ]
  },
];

export const AUTO_PRICES = [
  { code: "AP01", name: "엔진오일 (5W-30)", spec: "1L", unit: "L", price: 8000, net_g: 1, category: "오일·유체" },
  { code: "AP02", name: "오일필터", spec: "ea", unit: "ea", price: 5000, net_g: 1, category: "오일·유체" },
];

// ── 세탁 업종 기본 데이터 ──────────────────────────────────────────
export const LAUNDRY_CATEGORIES = [
  {
    name: "세탁 서비스",
    items: [
      { id: "LT01", recipeCode: "LT001", name: "일반 세탁 (상의)", type: "menu", total_output: 1, total_input: 1, serving_g: 1, note: "상의 1벌 기준", selling_price: 0, ingredients: [{ name: "세탁세제", qty: 30, unit: "g", lossRate: 0 }] },
      { id: "LT02", recipeCode: "LT002", name: "드라이클리닝 (재킷)", type: "menu", total_output: 1, total_input: 1, serving_g: 1, note: "재킷 1벌 기준", selling_price: 0, ingredients: [{ name: "클리닝 용제", qty: 50, unit: "mL", lossRate: 5 }] },
    ]
  },
];

export const LAUNDRY_PRICES = [
  { code: "LP01", name: "세탁세제", spec: "1kg", unit: "g", price: 8, net_g: 1, category: "세탁용품" },
  { code: "LP02", name: "클리닝 용제", spec: "1L", unit: "mL", price: 15, net_g: 1, category: "세탁용품" },
];
